// @oasis-permission-inherits: /videos (mirage-videos:view)
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dash/videos/evals")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
